.ugc-review-dt-images-detail-modal {
  width: 100%;
  max-height: 80vh;
  min-height: 25vh;
  overflow-y: auto;

  .nav-button {
    width: 24px;
    height: 48px;
    padding: 14px 0 14px 4px;
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.16);
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    top: calc(50% - 24px);
    z-index: 10;
    &.button-prev {
      @at-root [dir='ltr'] & {
        border-radius: 0 100px 100px 0;
        left: 0;
        svg {
          transform: rotate(-270deg);
        }
      }
      @at-root [dir='rtl'] & {
        border-radius: 100px 0 0 100px;
        right: 0;
        svg {
          transform: rotate(270deg);
        }
      }
    }

    &.button-next {
      @at-root [dir='ltr'] & {
        border-radius: 100px 0 0 100px;
        right: 0;
        svg {
          transform: rotate(-90deg);
        }
      }
      @at-root [dir='rtl'] & {
        border-radius: 0 100px 100px 0;
        left: 0;
        svg {
          transform: rotate(90deg);
        }
      }
    }
  }

  .big-image-wrap {
    position: relative;
    width: 378px;
    height: 378px;

    .image-swiper-wrap {
      position: absolute;
      top: 0;
      left: 0;
      width: 378px;
      height: 378px;
      border-radius: 8px;
      opacity: 1;
      transition: opacity 0.5s linear;
      background: #fff;
      &.active {
        z-index: 9;
      }
      img {
        width: 100%;
        height: auto;
        border-radius: 8px;
        transition: opacity 0.5s linear;
      }
    }
  }

  .image-detail-review-info-wrap {
    flex: 1;
    max-height: 378px;
  }

  .swipper-image-list-box {
    max-width: 100%;
    height: 104px;
    overflow: hidden;
    .swipper-image-list {
      transform: translateX(0);
      height: 104px;
      transition: all 0.2s linear;
      .swipper-image-box {
        flex-shrink: 0;
        width: 104px;
        height: 104px;
        border-radius: 12px;
        transition: all 0.2s linear;
        position: relative;
        > .active {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba($color: #000000, $alpha: 0.4);
          border-radius: 12px;
        }
        img {
          width: 100%;
          border-radius: 12px;
        }
      }
    }
  }
}
@media screen and (max-width: 1050px) {
  .ugc-review-dt-all-images-detail-modal,
  .ugc-review-dt-image-modal {
    .modal-dialog-root {
      width: 600px !important;
    }
    .ugc-review-dt-images-detail-modal {
      .big-image-wrap {
        width: 278px !important;
        height: 278px !important;
        .image-swiper-wrap {
          width: 278px !important;
          height: 278px !important;
        }
      }
      .image-detail-review-info-wrap {
        flex: 1;
        max-height: 278px;
      }
    }
  }
}
